import { useQuery } from '@tanstack/react-query';

import TrackerEvents from '@/core/libs/event-tracker/TrackerEvents.enum';
import { useSearchTracking } from '@/modules/matchmaking/hooks/useSearchTracking';
import { SearchOptions, SearchService } from '@/generated/api';

function isSearchEmpty(payload: SearchOptions): boolean {
  const {
    parts,
    countries,
    certificationIds,
    companySizeCategories,
    hasMetrologyMachines,
    isVerified,
    hasCapacity,
    partTypes,
  } = payload;

  const isPartsEmpty = !parts || parts.length === 0;

  const hasOtherCriteria =
    (countries && countries.length > 0) ||
    (certificationIds && certificationIds.length > 0) ||
    (companySizeCategories && companySizeCategories.length > 0) ||
    (partTypes && partTypes.length > 0) ||
    hasMetrologyMachines === true ||
    isVerified === true ||
    hasCapacity === true;

  return isPartsEmpty && !hasOtherCriteria;
}

export function useSearchManufacturers(
  payload: SearchOptions,
  noTracking = false,
  enabled = true,
) {
  const { trackEventWithNewSearch } = useSearchTracking();

  return useQuery({
    queryKey: ['searchManufacturers', payload, noTracking],
    enabled: enabled,
    queryFn: async () => {
      if (!noTracking && !isSearchEmpty(payload)) {
        trackEventWithNewSearch(TrackerEvents.SEARCH_QUERY_V3, payload);
      }

      return SearchService.manufacturerSearchControllerGetManufacturersPost(
        payload,
        noTracking ? 'true' : undefined,
      );
    },
    refetchOnWindowFocus: false,
  });
}
